<template>
  <div
    class="banner-slider-container"
    :class="`position-${config.templateBlock.codInt}`"
  >
    <ebsn-meta
      :target="config"
      path="categoryblocktype_BannerSlider.TITLE"
      tag="h2"
      :class="' banner-slider-title text-center '"
    />
    <ebsn-meta
      :target="config"
      path="categoryblocktype_BannerSlider.DESCRIPTION"
      tag="div"
      :class="' banner-slider-description text-center '"
    />

    <div class="slider banner-slider">
      <swiper :options="swiperOption" ref="swiperRef">
        <swiper-slide v-for="proposal in config.proposals" :key="proposal.id">
          <component
            :is="getProposalModelName(proposal)"
            :proposal="proposal"
            :position="config.templateBlock.codInt"
          />
        </swiper-slide>
      </swiper>
      <div
        v-if="
          $ebsn.meta(
            config,
            'categoryblocktype_BannerSlider.SHOW_BULLETS',
            true
          ) && config.proposals.length > 1
        "
        :id="`banner-pagination-${config.categoryBlockId}`"
        class="swiper-pagination"
      ></div>
      <div
        v-if="
          $ebsn.meta(
            config,
            'categoryblocktype_BannerSlider.SHOW_ARROWS',
            false
          ) && config.proposals.length > 1
        "
        :id="`banner-slider-prev-${config.categoryBlockId}`"
        class="swiper-button-prev"
      ></div>
      <div
        v-if="
          $ebsn.meta(
            config,
            'categoryblocktype_BannerSlider.SHOW_ARROWS',
            false
          ) && config.proposals.length > 1
        "
        :id="`banner-slider-next-${config.categoryBlockId}`"
        class="swiper-button-next"
      ></div>
    </div>
  </div>
</template>
<style lang="scss">
.banner-slider-container {
  .banner-slider-title {
    color: var(--v-primary-lighten1);
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .banner-slider-description {
    margin-bottom: 16px;
  }
  .banner-slider {
    .swiper-slide {
      height: auto;
      .proposal-card.v-card {
        height: 100%;
        display: flex;
        flex-direction: column;
      }
    }
    // @media #{map-get($display-breakpoints, 'xs-only')} {
    //   .swiper-button-prev,
    //   .swiper-button-next {
    //     display: none;
    //   }
    // }
    // @media #{map-get($display-breakpoints, 'sm-and-up')} {
    //   .swiper-pagination {
    //     display: none;
    //   }
    // }
  }
}
</style>
<script>
import ProposalImage from "./elements/ProposalImage.vue";
import ProposalCard from "./elements/ProposalCard.vue";
import ProposalCardOverlay from "./elements/ProposalCardOverlay.vue";
import ProposalButton from "./elements/ProposalButton.vue";

import deliveryReactive from "~/mixins/deliveryReactive";
import categoryBlockType from "./categoryBlockType";

export default {
  name: "BannerSlider",
  props: {
    config: { type: Object, required: true },
    container: { type: Boolean, default: true }
  },
  components: {
    ProposalImage,
    ProposalCard,
    ProposalCardOverlay,
    ProposalButton
  },
  mixins: [deliveryReactive, categoryBlockType],
  data() {
    return {
      swiperRef: null,
      swiperDefaultOption: {
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay: true,
        watchOverflow: true,
        loop: false,
        pagination: {
          el: `#banner-pagination-${this.config.categoryBlockId}`,
          clickable: true
        },
        navigation: {
          prevEl: `#banner-slider-prev-${this.config.categoryBlockId}`,
          nextEl: `#banner-slider-next-${this.config.categoryBlockId}`
        }
      }
    };
  },
  methods: {
    reload() {
      if (this.$refs.swiperRef.swiperInstance) {
        this.$refs.swiperRef.swiperInstance.slideTo(0);
      }
      if (!this.config.proposals || this.config.proposals.length < 1) {
        this.$emit("hide");
      }
    }
  },
  created() {
    this.$emit("hide");
  }
};
</script>
